import { BlueBirdTheme } from "@kitbird/core";
import styled from "styled-components";

export const DropdownWrapper = styled.div<{ $width: string, $disabled?: boolean }>`
  > div > div:nth-child(1) > div {
    background-color: ${({ $disabled }) => ($disabled ? BlueBirdTheme.colors.gray.background : BlueBirdTheme.colors.primary[100])};
    border: none;
    width: ${({ $width }) => $width};
    height: 24px;
  }

  > div > div:nth-child(2) > div {
    overflow-y: auto;
  }
  div[disabled] {
    background-color: transparent;
  }
`;

export default DropdownWrapper;
